import React, { createContext, useContext, useState } from 'react';

// Create context
const SelectedDateMatchProbContext = createContext();

// Provider component
export const SelectedDateMatchProbProvider = ({ children }) => {
  const [dateFrom, setDateFrom] = useState(new Date()); // Default to current date
  const [dateTo, setDateTo] = useState(new Date()); // Default to current date

  return (
    <SelectedDateMatchProbContext.Provider value={{ dateFrom, setDateFrom, dateTo, setDateTo }}>
      {children}
    </SelectedDateMatchProbContext.Provider>
  );
};

// Custom hook for easy access to the context
export const useSelectedDate = () => useContext(SelectedDateMatchProbContext);
